import { Directive } from '@angular/core';

@Directive({
  selector: 'phx-text-line, [phx-text-line]',
  host: { class: 'phx-text-line' },
})
export class PhxListItemTextLineDirective { }
